import {define} from './define'
import type {GroupReturn} from '../types'

export const meta = (): GroupReturn => define('meta')
